import { connect } from 'react-redux'
import type { RootState } from 'shared/store/reducers'
import { EcommerceRouteComponent } from './EcommerceRouteComponent'
import { getMostRecentOrder } from 'shared/utils/ecommerce/utils'

const mapStateToProps = (state: RootState) => {
    const {
        restaurant,
        collectMode,
        cacOrders,
        currentToken
    } = state.ecommerceOrderState
    const { authenticated } = state.userState
    const localOrder = currentToken && cacOrders && cacOrders[currentToken]

    const mostRecentOrder = getMostRecentOrder(cacOrders)

    return {
        hasAuthentication: authenticated,
        hasRestaurant: restaurant !== undefined,
        hasCollectMode: !!collectMode,
        hasCurrentOrder: localOrder && localOrder.id,
        mostRecentOrderHasbeenPaid: !!mostRecentOrder
    }
}

const EcommerceRoute = connect(mapStateToProps)(EcommerceRouteComponent)

export { EcommerceRoute }
